<template>
    <div class="main-container pt-1 pb-5 xl:px-16">
        <Toast />
        <div v-if="isAdmin">
            <div class="flex justify-center pt-2">
                <SelectButton v-model="showing" optionValue="value" :options="showingOptions" optionLabel="label"
                    dataKey="value" aria-labelledby="basic" />
            </div>
            <AdminVoonixAdvertisersTable v-if="showing !== 'settings'" :showing="showing" />
            <AdminVoonixAdvertisersSettingsTable v-if="showing == 'settings'" />
        </div>
    </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from 'vue-router';
import AdminVoonixAdvertisersSettingsTable from "./Settings/AdvertisersSettingsTable.vue";
import AdminVoonixAdvertisersTable from './AdvertisersTable.vue';
import { useStore } from 'vuex';
const route = useRoute();

const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);

const showingOptions = ref([
    { label: 'Show Only Requested', value: 'requested' },
    { label: 'All', value: 'all' },
    { label: 'Settings', value: 'settings' }]);

const showing = ref('settings');

// Check query parameter on component mount
onMounted(() => {
    const queryShowing = route.query.showing;
    if (queryShowing && showingOptions.value.some(option => option.value === queryShowing)) {
        showing.value = queryShowing;
    }
});

// Watch for changes in the route query parameter and update showing
watch(() => route.query.showing, (newValue) => {
    if (newValue && showingOptions.value.some(option => option.value === newValue)) {
        showing.value = newValue;
    }
});

</script>

<style scoped>
/* Your styles here */
.modal-content {
    width: 100vw;
}
</style>